import CTAMembership from './cta-membership';
import '@/components/cta/cta-become-a-member';
import '@/components/cta/cta-open-access';

const ctaMembershipConfig = {
  name: 'ctaMembership',
  class: CTAMembership,
  querySelector: {},
  querySelectorAll: {},
  options: {},
};

export default ctaMembershipConfig;
